import { useMemo } from 'react';
import { BotState } from '../../../../types';
import StateListItem from './Item';

import './index.css';
import LoadingIcons from 'react-loading-icons';

interface Props {
  data: Array<BotState>;
  handleMove: (state: BotState) => void;
  handleStopAll: () => void;
  handleStartAll: () => void;
  isLoading: boolean;
}

const StateList = (props: Props) => {
  const { data, handleMove, handleStopAll, handleStartAll, isLoading } = props;

  const activeBotStates = useMemo(() => data.filter((b) => b.isActive), [data]);
  const nonActiveBotStates = useMemo(
    () => data.filter((b) => !b.isActive),
    [data],
  );

  if (isLoading && !activeBotStates?.length && !nonActiveBotStates?.length) {
    return (
      <div className="states-loading">
        <LoadingIcons.Grid width={80} />
      </div>
    );
  }

  return (
    <div className="states-root">
      {activeBotStates?.length && (
        <>
          <div className="states-title-container">
            <p className="states-title">Active Bots</p>
            <div className="states-stop-button-small" onClick={handleStopAll}>
              {isLoading ? (
                <p className="states-button-text-small">Stopping...</p>
              ) : (
                <p className="states-button-text-small">Stop All</p>
              )}
            </div>
          </div>
          <div className="states-list-container">
            {activeBotStates.map((state) => (
              <StateListItem
                key={state.botId}
                state={state}
                handleMove={handleMove}
              />
            ))}
          </div>
        </>
      )}

      {nonActiveBotStates?.length && (
        <>
          <div className="states-title-container">
            <p className="states-title">Non-Active Bots</p>
            <div className="states-start-button-small" onClick={handleStartAll}>
              {isLoading ? (
                <p className="states-button-text-small">Starting...</p>
              ) : (
                <p className="states-button-text-small">Start All</p>
              )}
            </div>
          </div>
          <div className="states-list-container">
            {nonActiveBotStates.map((state) => (
              <StateListItem
                key={state.botId}
                state={state}
                handleMove={handleMove}
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default StateList;
